var map = {
	"./emoji0.png": "24df",
	"./emoji1.png": "a664",
	"./emoji10.png": "3f4c",
	"./emoji11.png": "b77a",
	"./emoji12.png": "5109",
	"./emoji13.png": "c98e",
	"./emoji14.png": "cec3",
	"./emoji15.png": "0691",
	"./emoji2.png": "204d",
	"./emoji3.png": "f8a8",
	"./emoji4.png": "bfac",
	"./emoji5.png": "5b10",
	"./emoji6.png": "07b2",
	"./emoji7.png": "c5b0",
	"./emoji8.png": "1a4c",
	"./emoji9.png": "35a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f198";